document.addEventListener("DOMContentLoaded", function () {
  const banner = document.querySelector(".banner");

  if (!banner) return;

  setTimeout(function () {
    banner.classList.add("animation-active");
  }, 1000); // 3000ms = 3 seconds
});

document.addEventListener("DOMContentLoaded", function () {
  const btn = document.querySelector(".video-section .video-section__media button");
  if (!btn) return;
  setTimeout(function () {
    btn.click();
  }, 1000);
});

document.addEventListener("DOMContentLoaded", function(){

  new Swiper(".card-marquee", {
    slidesPerView: "auto",
    spaceBetween: 20,
    loop: true,
    speed: 6000,
    freeMode: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
  });

});


document.addEventListener("DOMContentLoaded", function () {
  const images = document.querySelectorAll(".gallery-image");
  const lightbox = document.getElementById("lightbox");
  const lightboxImg = document.getElementById("lightbox-img");
  const closeBtn = document.querySelector(".close");
  const nextBtn = document.querySelector(".next");
  const prevBtn = document.querySelector(".prev");

  let currentIndex = 0;
  const imageArray = Array.from(images);

  function showImage(index) {
    currentIndex = index;
    lightboxImg.src = imageArray[index].dataset.full;
    lightbox.style.display = "flex";
  }

  images.forEach((img, index) => {
    img.addEventListener("click", () => {
      showImage(index);
    });
  });

  closeBtn.addEventListener("click", () => {
    lightbox.style.display = "none";
  });

  nextBtn.addEventListener("click", () => {
    currentIndex = (currentIndex + 1) % imageArray.length;
    showImage(currentIndex);
  });

  prevBtn.addEventListener("click", () => {
    currentIndex = (currentIndex - 1 + imageArray.length) % imageArray.length;
    showImage(currentIndex);
  });

  lightbox.addEventListener("click", function(e){
    if(e.target === lightbox){
      lightbox.style.display = "none";
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".accordion details");

  accordions.forEach((details) => {
    const content = details.querySelector(".accordion__content");

    // Set initial height
    if (details.open) {
      content.style.height = content.scrollHeight + "px";
    } else {
      content.style.height = "0px";
    }

    details.addEventListener("toggle", function () {

      // Close other accordions
      if (details.open) {
        accordions.forEach((other) => {
          if (other !== details) {
            other.removeAttribute("open");
          }
        });

        content.style.height = content.scrollHeight + "px";
      } else {
        content.style.height = "0px";
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.product-swiper', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,

      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
    });
  });


document.addEventListener("DOMContentLoaded", function () {
  const dropdown = document.querySelector(".product-share-dropdown");
  const toggle = dropdown.querySelector(".share-toggle");
  const menu = dropdown.querySelector(".share-menu");
  const copyBtn = dropdown.querySelector(".copy-link");

  toggle.addEventListener("click", function (e) {
    e.stopPropagation();
    menu.classList.toggle("active");
  });

  document.addEventListener("click", function () {
    menu.classList.remove("active");
  });

  copyBtn.addEventListener("click", function () {
    navigator.clipboard.writeText(window.location.href);
    alert("Link copied!");
    menu.classList.remove("active");
  });
});

// testimonial slider
$('.testi-slider').slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
        {
        breakpoint: 1024,
          settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
          }
        },
        {
        breakpoint: 600,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 2
          }
        },
        {
        breakpoint: 480,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1
          }
        }
    ]
});


document.addEventListener('DOMContentLoaded', function() {

  const faqItems = document.querySelectorAll('.faq-section .faq-item');

  if (faqItems.length > 0) {
    const firstItem = faqItems[0];
    const firstAnswer = firstItem.querySelector('.faq-answer');

    firstItem.classList.add('active');
    firstAnswer.style.maxHeight = firstAnswer.scrollHeight + "px";
  }

  document.querySelectorAll('.faq-section .faq-question')
    .forEach(button => {

      button.addEventListener('click', function() {

        const item = this.closest('.faq-item');
        const answer = item.querySelector('.faq-answer');

        if (item.classList.contains('active')) {
          answer.style.maxHeight = null;
          item.classList.remove('active');
        } else {

          /* Close all others */
          faqItems.forEach(el => {
            el.classList.remove('active');
            el.querySelector('.faq-answer').style.maxHeight = null;
          });

          item.classList.add('active');
          answer.style.maxHeight = answer.scrollHeight + "px";
        }

      });

  });

});


// accordion
$(".tabbbing-faq .accordion .title").click(function(){
  $(".content").not($(this).next()).slideUp();
  $(this).next().slideToggle();
});

document.addEventListener("DOMContentLoaded", function () {

  // Run only on devices that support hover (desktop)
  if (window.matchMedia("(hover: hover)").matches) {

    const menuItems = document.querySelectorAll('.section-header header nav details');

    menuItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        item.setAttribute('open', true);
      });

      item.addEventListener('mouseleave', () => {
        item.removeAttribute('open');
      });
    });

  }

});

document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".share-blog").forEach(function(button){

    button.addEventListener("click", function(){

      const url = this.getAttribute("data-url");

      navigator.clipboard.writeText(url);

      const notify = document.querySelector(".copy-notification");

      notify.classList.add("show");

      setTimeout(function(){
        notify.classList.remove("show");
      },2000);

    });

  });

});
